(function consultationForm(scope) {
  'use strict';
  const validation = scope.AgetaConsultationValidation;
  if (!validation) return;

  function init(root) {
    if (root.dataset.consultationBound === 'true') return;
    const form = root.querySelector('[data-consultation-form]');
    if (!form) return;
    root.dataset.consultationBound = 'true';
    let state = 'input';
    let sending = false;
    let requestId = '';
    let requestFingerprint = '';
    let confirmed = null;
    const summary = root.querySelector('[data-consultation-errors]');
    const confirm = root.querySelector('[data-consultation-confirm]');
    const send = root.querySelector('[data-consultation-send]');
    const back = root.querySelector('[data-consultation-back]');
    const enabled = root.dataset.enabled === 'true';
    const endpoint = new URL(form.action, scope.location.href);
    const endpointValid = endpoint.origin === scope.location.origin && /^\/(?:apps|a|community|tools)\/[a-z0-9_-]+\/submit$/u.test(endpoint.pathname) && !endpoint.search && !endpoint.hash;

    function show(next) {
      state = next;
      root.dataset.consultationState = next;
      root.querySelectorAll('[data-consultation-state]').forEach((el) => { el.hidden = el.dataset.consultationState !== next; });
      form.hidden = next === 'complete';
    }
    function clearErrors() {
      summary.hidden = true;
      summary.textContent = '';
      root.querySelectorAll('[data-field-error]').forEach((el) => { el.hidden = true; el.textContent = ''; });
      for (const key of Object.keys(validation.labels)) form.elements.namedItem(key)?.removeAttribute('aria-invalid');
    }
    function error(message, fieldErrors = {}) {
      summary.textContent = message;
      summary.hidden = false;
      for (const [key, messageText] of Object.entries(fieldErrors)) {
        if (!Object.hasOwn(validation.labels, key)) continue;
        const target = root.querySelector(`[data-field-error="${key}"]`);
        if (target) { target.textContent = messageText; target.hidden = false; form.elements.namedItem(key)?.setAttribute('aria-invalid', 'true'); }
      }
      summary.focus({ preventScroll: true });
      summary.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
    function read() {
      return validation.validate({ ...Object.fromEntries(new FormData(form)), privacyConsent: form.elements.namedItem('privacyConsent').checked });
    }
    function focusHeading(selector) {
      const heading = root.querySelector(selector);
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
    confirm.disabled = !enabled || !endpointValid;
    show('input');
    if (enabled && !endpointValid) error('ただいま投稿を受け付けられません。時間をおいて再度お試しください。');
    back.addEventListener('click', () => {
      if (sending) return;
      clearErrors();
      show('input');
      form.elements.namedItem('name').focus();
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (sending || !enabled || !endpointValid || state === 'complete') return;
      clearErrors();
      const result = read();
      if (!result.valid) {
        show('input');
        error('入力内容をご確認ください。', result.errors);
        return;
      }
      if (state === 'input' || JSON.stringify(result.values) !== JSON.stringify(confirmed)) {
        confirmed = result.values;
        for (const [key, value] of Object.entries(confirmed)) root.querySelector(`[data-preview="${key}"]`).textContent = key === 'privacyConsent' ? '同意する' : value || '未入力';
        show('confirm');
        focusHeading('[data-confirm-heading]');
        return;
      }
      const fingerprint = JSON.stringify(confirmed);
      sending = true;
      send.disabled = true;
      back.disabled = true;
      form.setAttribute('aria-busy', 'true');
      root.querySelector('[data-consultation-sending]').hidden = false;
      const controller = new AbortController();
      const timer = scope.setTimeout(() => controller.abort(), 25000);
      try {
        if (!requestId || fingerprint !== requestFingerprint) {
          requestId = scope.crypto.randomUUID();
          requestFingerprint = fingerprint;
        }
        const response = await scope.fetch(endpoint.href, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ ...confirmed, requestId, website: form.elements.namedItem('website').value }),
          signal: controller.signal,
        });
        const body = await response.json().catch(() => null);
        if (response.status === 422 && body?.errors) {
          show('input');
          error('入力内容をご確認ください。', body.errors);
        } else if (response.ok && body?.ok === true && body.receiptId === requestId) {
          root.querySelector('[data-consultation-reference]').textContent = body.receiptId;
          form.reset();
          confirmed = null;
          requestFingerprint = '';
          root.querySelectorAll('[data-preview]').forEach((el) => { el.textContent = ''; });
          show('complete');
          focusHeading('[data-complete-heading]');
        } else if (response.status === 429) {
          error('送信が集中しています。1分ほど待ってから、もう一度送信してください。');
        } else {
          error('受付を確認できませんでした。入力内容は保持しています。時間をおいて、もう一度送信してください。');
        }
      } catch {
        error('通信を確認できませんでした。入力内容は保持しています。接続を確認して、もう一度送信してください。');
      } finally {
        scope.clearTimeout(timer);
        sending = false;
        send.disabled = false;
        back.disabled = false;
        form.removeAttribute('aria-busy');
        root.querySelector('[data-consultation-sending]').hidden = true;
      }
    });
  }
  function initialize(container) {
    if (container.matches?.('[data-consultation-form-root]')) init(container);
    container.querySelectorAll('[data-consultation-form-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
}(window));
